module.exports = __webpack_public_path__ + "media/images/hitfun/icon.prize.money-aa5b6b1d4dc54e155a8a94d4f709c35f.svg";